<template>
  <el-drawer v-model="visible" title="订单入住人" size="620px">
    <el-descriptions v-if="order" :column="2" border class="mb-16px">
      <el-descriptions-item label="订单号">{{ order.orderNo }}</el-descriptions-item>
      <el-descriptions-item label="房间">{{ order.roomNo || '-' }}</el-descriptions-item>
    </el-descriptions>
    <el-button type="primary" class="mb-12px" @click="openForm()"
      ><Icon icon="ep:plus" />新增入住人</el-button
    >
    <el-table :data="order?.guests || []" border>
      <el-table-column prop="name" label="姓名" /><el-table-column prop="phone" label="手机" />
      <el-table-column prop="idNumber" label="证件号" min-width="160" /><el-table-column
        label="主入住人"
        width="90"
        ><template #default="s">{{
          s.row.isPrimary === 1 ? '是' : '否'
        }}</template></el-table-column
      >
      <el-table-column label="操作" width="120"
        ><template #default="s"
          ><el-button link type="primary" @click="openForm(s.row)">编辑</el-button
          ><el-button link type="danger" @click="remove(s.row.id)">删除</el-button></template
        ></el-table-column
      >
    </el-table>
    <Dialog v-model="formVisible" :title="form.id ? '编辑入住人' : '新增入住人'" width="500px">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="姓名" prop="name"><el-input v-model="form.name" /></el-form-item>
        <el-form-item label="证件类型" prop="idType"
          ><el-select v-model="form.idType"
            ><el-option label="身份证" value="ID_CARD" /><el-option
              label="护照"
              value="PASSPORT" /><el-option label="其他" value="OTHER" /></el-select
        ></el-form-item>
        <el-form-item label="证件号" prop="idNumber"
          ><el-input v-model="form.idNumber"
        /></el-form-item>
        <el-form-item label="手机号" prop="phone"><el-input v-model="form.phone" /></el-form-item>
        <el-form-item label="性别"
          ><el-radio-group v-model="form.gender"
            ><el-radio :value="0">未知</el-radio><el-radio :value="1">男</el-radio
            ><el-radio :value="2">女</el-radio></el-radio-group
          ></el-form-item
        >
        <el-form-item label="主入住人"><el-switch v-model="primary" /></el-form-item>
        <el-form-item label="关联房间"
          ><el-select v-model="form.roomId" clearable
            ><el-option
              v-if="order?.roomId"
              :label="order.roomNo || String(order.roomId)"
              :value="order.roomId" /></el-select
        ></el-form-item>
      </el-form>
      <template #footer
        ><el-button @click="formVisible = false">取消</el-button
        ><el-button type="primary" :loading="saving" @click="submit">保存</el-button></template
      >
    </Dialog>
  </el-drawer>
</template>
<script setup lang="ts">
import * as BookingApi from '@/api/hotel/bookingOrder'
import * as GuestApi from '@/api/hotel/orderGuest'
const message = useMessage()
const visible = ref(false)
const formVisible = ref(false)
const saving = ref(false)
const formRef = ref()
const order = ref<BookingApi.BookingOrderVO>()
const form = reactive<GuestApi.OrderGuestVO>({
  orderId: 0,
  name: '',
  idType: 'ID_CARD',
  gender: 0,
  isPrimary: 0
})
const primary = computed({
  get: () => form.isPrimary === 1,
  set: (value) => (form.isPrimary = value ? 1 : 0)
})
const isValidIdCard = (value: string) => {
  if (!/^[1-9]\d{16}[0-9Xx]$/.test(value)) return false
  const year = Number(value.slice(6, 10))
  const month = Number(value.slice(10, 12))
  const day = Number(value.slice(12, 14))
  const parsed = new Date(year, month - 1, day)
  if (
    parsed.getFullYear() !== year ||
    parsed.getMonth() !== month - 1 ||
    parsed.getDate() !== day ||
    parsed > new Date()
  )
    return false
  const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
  const checks = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
  const sum = weights.reduce((total, weight, index) => total + Number(value[index]) * weight, 0)
  return value[17].toUpperCase() === checks[sum % 11]
}
const rules = {
  name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
  idType: [{ required: true, message: '请选择证件类型', trigger: 'change' }],
  idNumber: [
    {
      validator: (_rule: any, value: string, callback: (error?: Error) => void) => {
        if (form.idType === 'ID_CARD' && !value?.includes('*') && !isValidIdCard(value?.trim())) {
          callback(new Error('请输入正确的18位身份证号码'))
          return
        }
        callback()
      },
      trigger: ['blur', 'change']
    }
  ],
  phone: [{ pattern: /^$|^1\d{10}$/, message: '请输入正确的11位手机号', trigger: 'blur' }]
}
const reload = async () => {
  if (order.value) order.value = await BookingApi.getDetailWithGuests(order.value.id)
}
const open = async (id: string | number) => {
  visible.value = true
  order.value = await BookingApi.getDetailWithGuests(id)
}
const openForm = (row?: GuestApi.OrderGuestVO) => {
  Object.assign(
    form,
    {
      id: undefined,
      orderId: order.value!.id,
      roomId: order.value!.roomId,
      name: '',
      idType: 'ID_CARD',
      idNumber: '',
      phone: '',
      gender: 0,
      isPrimary: 0
    },
    row || {}
  )
  formVisible.value = true
}
const submit = async () => {
  const valid = await formRef.value?.validate()
  if (!valid) return
  saving.value = true
  try {
    form.id ? await GuestApi.updateOrderGuest(form) : await GuestApi.createOrderGuest(form)
    message.success('入住人保存成功')
    formVisible.value = false
    await reload()
  } finally {
    saving.value = false
  }
}
const remove = async (id: string | number) => {
  await message.delConfirm()
  await GuestApi.deleteOrderGuest(id)
  await reload()
}
defineExpose({ open })
</script>
